import { combineRoutes } from '../utils/routeUtil';

// routess
import authRoute from './authRoute';
import bankRoute from './bankRoute';
import courierRoute from './courierRoute';
import creditCollectionRoute from './creditCollectionRoute';
import customerAgingRoute from './customerAgingRoute';
import dealsAndDiscountLogsRoute from './dealsAndDiscountLogsRoute';
import dealsAndDiscountRoute from './dealsAndDiscountRoute';
import DebitMemoRoute from './debitMemoRoute';
import generalLedgerRoute from './generalLedgerRoute';
import guestRoute from './guestRoute';
import inventoryRoute from './inventoryRoute';
import ledgerRoute from './ledgerRoute';
import mdProgramProjextExpenseReportRoute from './mdProgramProjextExpenseReportRoute';
import oldRoute from './oldRoute';
import payableManagementRoute from './payableManagementRoute';
import permissionRoute from './permissionRoute';
import purchaseOrderRoute from './purchaseOrderRoute';
import purchasingRoute from './purchasingRoute';
import salesInvoiceRoute from './salesInvoiceRoute';
import smppProductMaintenanceRoute from './smppProductMaintenanceRoute';
import systemNotificationRoute from './systemNotificationRoute';
import tokenRoute from './tokenRoute';
import treasuryRoute from './treasuryRoute';
import trialBalanceRoute from './trialBalanceRoute';
import vendorRoute from './vendorRoute';
import warehouseRoute from './warehouseRoute';

// all accounting route will go under this comment
import chartOfAccountRoute from './chartOfAccountRoute';
import checkVoucherRoute from './checkVoucherRoute';
import costCenterRoute from './costCenterRoute';
import divisionRoute from './divisionRoute';
import payableVoucherRoute from './payableVoucherRoute';

// SRPF ROUTE
import InventoryInvoicedSubledgerRoute from './InventoryInvoicedSubledgerRoute';
import advancesSubledgderRoute from './advancesSubledgderRoute';
import advancesToSupplierNonTradeRoute from './advancesToSupplierNonTradeRoute';
import advancesToVendorsRoute from './advancesToVendorsRoute';
import assetManagementRoute from './assetManagementRoute';
import assetReceivedButNotYetInvoicedRoute from './assetReceivedButNotYetInvoicedRoute';
import balanceSheetNewFormatRoute from './balanceSheetNewFormatRoute';
import cashAdvanceRoute from './cashAdvanceRoute';
import creditMemoSubledgderRoute from './creditMemoSubledgderRoute';
import ewtReportRoute from './ewtReportRoute';
import historyRoute from './historyRoute';
import mdExpensesReportRoute from './mdExpensesReportRoute';
import transactionListingRoute from './transactionListingRoute';

import auditLockAdminRoute from './auditLockAdminRoute';
import auditLockApprovalRoute from './auditLockApprovalRoute';
import auditLockRequestorRoute from './auditLockRequestorRoute';
import balanceSheetRoute from './balanceSheetRoute';
import cashInBankSubledgerRoute from './cashInBankSubledgerRoute';
import coaTaggingRoute from './coaTaggingRoute';
import comprehensiveIncomeRoute from './comprehensiveIncomeRoute';
import creditAssessmentRoute from './creditAssessmentRoute';
import creditMemoMonitoringReportRoute from './creditMemoMonitoringReportRoute';

import cwtRoute from './cwtRoute';
import cwtSubledgerRoute from './cwtSubledgerRoute';
import entryMaintenanceRoute from './entryMaintenanceRoute';
import ewtSubledgerRoute from './ewtSubledgerRoute';
import expenseSubledgerRoute from './expenseSubledgerRoute';
import incomeStatementRoute from './incomeStatementRoute';
import inputVatRoute from './inputVatRoute';
import inventoryReceivedNotYetInvoicedRoute from './inventoryReceivedNotYetInvoicedRoute';
import journalVoucherRoute from './journalVoucherRoute';
import liabilitySubledgerRoute from './liabilitySubledgerRoute';
import lockTransactionRoute from './lockTransactionRoute';
import outputVatRoute from './outputVatRoute';
import programProjectRoute from './programProjectRoute';
import qneRoute from './qneRoute';
import salesJournalLists from './salesJournalRoute';
import shareholdersEquityReportRoute from './shareholdersEquityReportRoute';
import srpfRoute from './srpfRoute';
import statementOfAccountRoute from './statementOfAccountRoute';
import statementOfCashFlowRoute from './statementOfCashFlowRoute';
import tradeNonTradePayableRoute from './tradeNonTradePayableRoute';

import mdProfileRoute from './mdProfileRoute';
import trialBalanceV2Route from './trialBalanceV2Route';

import employeeDatabaseRoute from './employeeDatabaseRoute';
import paymentTermsComplianceRoute from './paymentTermsComplianceRoute';
import undefinedDepositSubLedgerReportRoute from './undefinedDepositSubLedgerReportRoute';
import undefinedDepositSubledgerV2Route from './undefinedDepositSubledgerV2Route';
import nonTradeCollectionScreenRoute from './nonTradeCollectionScreenRoute';

import BeginningAndEndingBalanceCheckerRoute from './BeginningAndEndingBalanceCheckerRoute';
import slBuilderRoute from './slBuilderRoute';

//routes
export default combineRoutes([
  oldRoute,
  bankRoute,
  inventoryRoute,
  ledgerRoute,
  trialBalanceRoute,
  generalLedgerRoute,
  customerAgingRoute,
  courierRoute,
  creditCollectionRoute,
  treasuryRoute,
  guestRoute,
  tokenRoute,
  salesInvoiceRoute,
  smppProductMaintenanceRoute,
  systemNotificationRoute,
  dealsAndDiscountRoute,
  permissionRoute,
  warehouseRoute,
  authRoute,
  journalVoucherRoute,
  dealsAndDiscountLogsRoute,
  DebitMemoRoute,
  authRoute,
  vendorRoute,
  purchaseOrderRoute,
  dealsAndDiscountLogsRoute,
  chartOfAccountRoute,
  srpfRoute,
  balanceSheetRoute,
  incomeStatementRoute,
  checkVoucherRoute,
  payableManagementRoute,
  purchasingRoute,
  programProjectRoute,
  coaTaggingRoute,
  costCenterRoute,
  divisionRoute,
  assetManagementRoute,
  payableVoucherRoute,
  costCenterRoute,
  divisionRoute,
  chartOfAccountRoute,
  assetManagementRoute,
  expenseSubledgerRoute,
  liabilitySubledgerRoute,
  balanceSheetNewFormatRoute,
  advancesSubledgderRoute,
  creditMemoSubledgderRoute,
  transactionListingRoute,
  mdExpensesReportRoute,
  ewtReportRoute,
  historyRoute,
  cashAdvanceRoute,
  statementOfAccountRoute,
  undefinedDepositSubLedgerReportRoute,
  InventoryInvoicedSubledgerRoute,
  tradeNonTradePayableRoute,
  cashInBankSubledgerRoute,
  transactionListingRoute,
  mdProfileRoute,
  cwtSubledgerRoute,
  ewtSubledgerRoute,
  entryMaintenanceRoute,
  transactionListingRoute,
  slBuilderRoute,
  salesJournalLists,
  cashInBankSubledgerRoute,
  creditAssessmentRoute,
  creditMemoMonitoringReportRoute,
  cwtRoute,
  inventoryReceivedNotYetInvoicedRoute,
  outputVatRoute,
  inputVatRoute,
  advancesToVendorsRoute,
  assetReceivedButNotYetInvoicedRoute,
  cashInBankSubledgerRoute,
  shareholdersEquityReportRoute,
  creditMemoMonitoringReportRoute,
  mdProgramProjextExpenseReportRoute,
  comprehensiveIncomeRoute,
  lockTransactionRoute,
  undefinedDepositSubLedgerReportRoute,
  statementOfCashFlowRoute,
  auditLockAdminRoute,
  auditLockRequestorRoute,
  auditLockApprovalRoute,
  undefinedDepositSubLedgerReportRoute,
  undefinedDepositSubledgerV2Route,
  BeginningAndEndingBalanceCheckerRoute,
  mdProfileRoute,
  qneRoute,
  advancesToSupplierNonTradeRoute,
  creditAssessmentRoute,
  paymentTermsComplianceRoute,
  trialBalanceV2Route,
  //cashAdvanceSubLedgerRoute,
  //cashAdvancedAgingRoute,
  undefinedDepositSubLedgerReportRoute,
  undefinedDepositSubledgerV2Route,
  employeeDatabaseRoute,
  advancesToSupplierNonTradeRoute,
  nonTradeCollectionScreenRoute
]);
